// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600&family=Poppins:wght@400;500;600;700&family=Roboto&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_wrapper__7DvFM {
  border-radius: 12px;
  background: var(--neutral-06100, #232627);
  box-shadow: 0 20px 24px 0 rgba(0, 0, 0, 0.5);
}

.styles_avatar__Hs50r {
  width: 40px;
  height: 40px;
  object-fit: cover;
  border-radius: 56px;
}

.styles_username__gqzWE {
  color: #FEFEFE;
  font-family: "Inter", sans-serif;
  font-weight: 600;
  font-size: 14px;
}

.styles_email__k0nci {
  color: rgba(232, 236, 239, 0.5019607843);
  font-family: "Inter", sans-serif;
  font-weight: 600;
  font-size: 12px;
}

.styles_settings__aE5SS {
  width: 100%;
  height: 48px;
  font-family: "Inter", sans-serif;
  font-weight: 600;
  background-color: #313333;
  border-radius: 12px;
  color: #FEFEFE;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 6px;
}

.styles_trialPlaceholder__PrVZ\\+ {
  position: absolute;
  top: -10px;
  right: 6px;
  width: 148px;
  height: 24px;
  border-radius: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.styles_trialPlaceholderDays__DqMNb {
  color: #FEFEFE;
  font-family: "Poppins", sans-serif;
  font-weight: 700;
  font-size: 12px;
  letter-spacing: -2%;
}`, "",{"version":3,"sources":["webpack://./src/layout/Dashboard/components/Sidebar/UserCard/styles.module.scss","webpack://./src/constants/colors.scss","webpack://./src/constants/fonts.scss"],"names":[],"mappings":"AAGA;EACE,mBAAA;EACA,yCAAA;EACA,4CAAA;AADF;;AAIA;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,mBAAA;AADF;;AAIA;EACE,cCbM;EDcN,gCEdM;EFeN,gBAAA;EACA,eAAA;AADF;;AAIA;EACE,wCAAA;EACA,gCErBM;EFsBN,gBAAA;EACA,eAAA;AADF;;AAIA;EACE,WAAA;EACA,YAAA;EACA,gCE7BM;EF8BN,gBAAA;EACA,yBAAA;EACA,mBAAA;EACA,cCjCM;EDmCN,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,QAAA;AAFF;;AAKA;EACE,kBAAA;EACA,UAAA;EACA,UAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EAEA,aAAA;EACA,uBAAA;EACA,mBAAA;AAHF;AAME;EACE,cCxDI;EDyDJ,kCE3DM;EF4DN,gBAAA;EACA,eAAA;EACA,mBAAA;AAJJ","sourcesContent":["@import 'constants/fonts.scss';\n@import 'constants/colors.scss';\n\n.wrapper {\n  border-radius: 12px;\n  background: var(--neutral-06100, #232627);\n  box-shadow: 0 20px 24px 0 rgba(0, 0, 0, 0.50);\n}\n\n.avatar {\n  width: 40px;\n  height: 40px;\n  object-fit: cover;\n  border-radius: 56px;\n}\n\n.username {\n  color: $white;\n  font-family: $inter;\n  font-weight: 600;\n  font-size: 14px;\n}\n\n.email {\n  color: #E8ECEF80;\n  font-family: $inter;\n  font-weight: 600;\n  font-size: 12px;\n}\n\n.settings {\n  width: 100%;\n  height: 48px;\n  font-family: $inter;\n  font-weight: 600;\n  background-color: #313333;\n  border-radius: 12px;\n  color: $white;\n\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  gap: 6px;\n}\n\n.trialPlaceholder {\n  position: absolute;\n  top: -10px;\n  right: 6px;\n  width: 148px;\n  height: 24px;\n  border-radius: 8px;\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n\n  &Days {\n    color: $white;\n    font-family: $poppins;\n    font-weight: 700;\n    font-size: 12px;\n    letter-spacing: -2%;\n  }\n}\n","$gray: #6C7275;\n$black: #313333;\n$blue: #0084FF;\n$green: #29B473;\n$white: #FEFEFE;\n","@import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600&family=Poppins:wght@400;500;600;700&family=Roboto&display=swap');\n\n$poppins: 'Poppins', sans-serif;\n$roboto: 'Roboto', sans-serif;\n$inter: 'Inter', sans-serif;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `styles_wrapper__7DvFM`,
	"avatar": `styles_avatar__Hs50r`,
	"username": `styles_username__gqzWE`,
	"email": `styles_email__k0nci`,
	"settings": `styles_settings__aE5SS`,
	"trialPlaceholder": `styles_trialPlaceholder__PrVZ+`,
	"trialPlaceholderDays": `styles_trialPlaceholderDays__DqMNb`
};
export default ___CSS_LOADER_EXPORT___;
